import { EditBase, Form, useEditContext, useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

import { FormToolbar } from "../layout/FormToolbar";
import type { Company } from "../types";
import { CompanyAside } from "./CompanyAside";
import { CompanyInputs } from "./CompanyInputs";
import { MobileFormToolbar, MobilePage } from "../layout/MobilePage";

export const CompanyEdit = () => {
  const isMobile = useIsMobile();
  return (
    <EditBase actions={false} redirect="show">
      {isMobile ? <CompanyEditMobile /> : <CompanyEditDesktop />}
    </EditBase>
  );
};

const CompanyEditDesktop = () => {
  const translate = useTranslate();
  return (
    <div className="mt-2 flex gap-8">
      <div className="flex-1">
        <h2 className="text-2xl font-bold tracking-tight mb-4">
          {translate("resources.companies.action.edit")}
        </h2>
        <Form className="flex flex-col gap-4 pb-2">
          <Card>
            <CardContent>
              <CompanyInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
      <CompanyAside link="show" />
    </div>
  );
};

const CompanyEditMobile = () => {
  const translate = useTranslate();
  const { record, isPending } = useEditContext<Company>();
  if (isPending || !record) return null;

  return (
    <MobilePage
      title={translate("resources.companies.action.edit")}
      backTo={`/companies/${record.id}/show`}
    >
      <Form className="flex flex-col gap-4">
        <CompanyInputs />
        <MobileFormToolbar />
      </Form>
    </MobilePage>
  );
};
